<template>
    <div
        v-if="element?.cover"
      class="relative bg-no-repeat bg-center bg-cover grow flex flex-col-reverse pb-6 lg:pb-10 h-[10rem] lg:h-[15rem]"
      :style="{
        backgroundImage: `url(${element?.cover})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }"
    >
      <div class="absolute inset-0 bg-[#4664b2] bg-opacity-40"></div>
      <div
        class="absolute inset-0 flex items-center justify-center text-white text-lg text-center lg:text-3xl font-bold"
      >

      </div>
      <div
      class="absolute inset-0 flex flex-col items-center justify-center text-white text-3xl font-bold"
    >
        <h1 v-if="currentLanguage === 'fr'">{{ element?.title }}</h1>
        <h1 v-if="currentLanguage === 'ar'">{{ element?.title_ar }}</h1>
        <h1 v-if="currentLanguage === 'ru'">{{ element?.title_ru }}</h1>
        <h1 v-if="currentLanguage === 'en'">{{ element?.title_en }}</h1>
        <h1 v-if="currentLanguage === 'zh'">{{ element?.title_zh }}</h1>
        <h1 v-if="currentLanguage === 'ko'">{{ element?.title_ko }}</h1>
        <h1 v-if="currentLanguage === 'ja'">{{ element?.title_ja }}</h1>



      <div class="text-xs lg:text-base font-semibold text-white mt-4">
        <p class="flex flex-row gap-2">
          <a aria-label="Lien Page accueil" class="hover:underline" :href="`/`">{{ $t("home") }}</a>
          <span v-if="currentLanguage === 'ar'">/</span>
          <span v-if="currentLanguage !== 'ar'">\</span>
          <a aria-label="Lien Page courant" class="hover:underline" :href="parentUrl">
            <span v-if="currentLanguage === 'fr'">{{ element?.title }}</span>
            <span v-if="currentLanguage === 'ar'">{{ element?.title_ar }}</span>
            <span v-if="currentLanguage === 'ru'">{{ element?.title_ru }}</span>
            <span v-if="currentLanguage === 'en'">{{ element?.title_en }}</span>
            <span v-if="currentLanguage === 'zh'">{{ element?.title_zh }}</span>
            <span v-if="currentLanguage === 'ko'">{{ element?.title_ko }}</span>
            <span v-if="currentLanguage === 'ja'">{{ element?.title_ja }}</span>
          </a>
        </p>
      </div>
    </div>
    </div>
    <div class="container p-3.5 sm:px-6 md:px-8 lg:px-16 xl:px-16 mx-auto my-2"         v-if="element"
    >
      <div class="container p-3.5 sm:px-6 md:px-8 lg:px-16 xl:px-16 mx-auto my-2">
        <div class="grid grid-cols-1 gap-2">
          <div>
            <h2 class="font-bold text-xl mb-3">{{ $t("description") }}</h2>
            <template v-if="currentLanguage === 'fr'">
              <div v-html="element?.description"></div>
            </template>
            <template v-if="currentLanguage === 'ar'">
              <div v-html="element?.description_ar"></div>
            </template>
            <template v-if="currentLanguage === 'ru'">
              <div v-html="element?.description_ru"></div>
            </template>
            <template v-if="currentLanguage === 'en'">
              <div v-html="element?.description_en"></div>
            </template>
            <template v-if="currentLanguage === 'zh'">
              <div v-html="element?.description_zh"></div>
            </template>
            <template v-if="currentLanguage === 'ko'">
              <div v-html="element?.description_ko"></div>
            </template>
            <template v-if="currentLanguage === 'ja'">
              <div v-html="element?.description_ja"></div>
            </template>
          </div>
        </div>
        <div v-if="element.medical_authorities" class="my-8">
            <DynamicMapPopUp
        :elements="element.medical_authorities"
        :icon="'/mapMarkers/medical-icon.png'"
      />
        </div>

 <div class="grid grid-cols-1 lg:grid-cols-4 gap-4 mt-4">
    <div
      v-for="(medical, index) in paginatedMedicalAuthorities"
      :key="index"
      class="col-span-1"
    >
      <MedicalCard :medical="medical" :routeSlug="element?.slug" />
    </div>
  </div>
        <div class="flex justify-center items-center gap-1 mt-6">
  <!-- Previous button -->
  <button
    @click="currentPage--"
    :disabled="currentPage === 1"
    class="w-8 h-8 flex items-center justify-center rounded-lg border text-sm font-medium"
    :class="currentPage === 1 ? 'text-gray-400 border-gray-300' : 'text-gray-700 border-gray-300 hover:bg-gray-100'"
  >
    ‹
  </button>

  <!-- Page number buttons with ellipsis -->
  <template v-for="(page, index) in pageNumbers" :key="index">
    <button
      v-if="page !== '...'"
      @click="currentPage = page"
      class="w-8 h-8 flex items-center justify-center rounded-lg border text-sm font-medium"
      :class="{
        'bg-[#4664b2] text-white border-[#4664b2]': currentPage === page,
        'text-gray-700 border-gray-300 hover:bg-gray-100': currentPage !== page
      }"
    >
      {{ page }}
    </button>
    <span v-else class="w-8 h-8 flex items-center justify-center text-gray-500">…</span>
  </template>

  <!-- Next button -->
  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages"
    class="w-8 h-8 flex items-center justify-center rounded-lg border text-sm font-medium"
    :class="currentPage === totalPages ? 'text-gray-400 border-gray-300' : 'text-gray-700 border-gray-300 hover:bg-gray-100'"
  >
    ›
  </button>
</div>

     
        <div
    class="container p-3.5 lg:px-12 min-1700:pl-6 min-1700:pr-12 mx-auto my-2 relative"
    v-if="this.imageListBanner1.length !== 0"
    data-aos="fade-up"
  >
    <BannerPub :images="this.imageListBanner1" />
  </div>
        <!-- <div
          class="container p-3.5 lg:px-16 xl:px-16 mx-auto my-2"
          v-if="
            this.imageListBanner1.length !== 0 ||
            this.imageListBanner2.length !== 0
          "
        >
          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8">
            <BannerPub
              class="block sm:hidden"
              :images="[...this.imageListBanner1, ...this.imageListBanner2]"
            />
            <BannerPub
              class="hidden sm:block"
              :images="
                this.imageListBanner1.length !== 0
                  ? this.imageListBanner1
                  : this.imageListBanner3
              "
            />
            <BannerPub
              class="hidden sm:block"
              :images="
                this.imageListBanner2.length !== 0
                  ? this.imageListBanner2
                  : this.imageListBanner3
              "
            />
          </div>
        </div> -->
      </div>
    </div>
  </template>
  <script>
  import { mapActions } from "vuex";
  import BannerPub from "../partial/BannerPub.vue";
   
  import MedicalCard from "./MedicalCard.vue";
  import DynamicMapPopUp from "./DynamicMapPopUp";
import { metaTagsPage } from "../utils/filters";

  export default {
    components: {
      BannerPub,
    
      MedicalCard,
      DynamicMapPopUp
    },
    props: {
      element: {
        type: Object,
        required: true,
      },
      parentUrl: String
    },
    computed: {
  totalPages() {
    return Math.ceil((this.element?.medical_authorities?.length || 0) / this.itemsPerPage);
  },
  paginatedMedicalAuthorities() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    return this.element?.medical_authorities?.slice(start, start + this.itemsPerPage) || [];
  },
  pageNumbers() {
    const pages = [];
    const total = this.totalPages;
    const current = this.currentPage;

    if (total <= 10) {
      for (let i = 1; i <= total; i++) pages.push(i);
    } else {
      if (current <= 7) {
        for (let i = 1; i <= 10; i++) pages.push(i);
        pages.push("...");
        pages.push(total - 1, total);
      } else if (current >= total - 6) {
        pages.push(1, 2);
        pages.push("...");
        for (let i = total - 9; i <= total; i++) pages.push(i);
      } else {
        pages.push(1, 2);
        pages.push("...");
        for (let i = current - 2; i <= current + 2; i++) pages.push(i);
        pages.push("...");
        pages.push(total - 1, total);
      }
    }

    return pages;
    },
  },
    data() {
      return {
        currentLanguage: this.$i18n.locale,
        imageListBanner1: [],
        imageListBanner2: [],
        imageListBanner3: [],
        articles: [],
            currentPage: 1,
            itemsPerPage: 16,
      };
    },
    methods: {
      ...mapActions(["fetchBanners", "fetchArticles"]),
      addCanonicalLink() {
        const currentUrl = window.location.href; // Get the current URL
        const currentLanguage = this.currentLanguage; // Fetch the current language
        let canonicalLink = document.querySelector("link[rel='canonical']");
  
        // Modify the URL based on the language
        const url = new URL(currentUrl);
        const pathSegments = url.pathname.split("/").filter(Boolean); // Remove empty segments
  
        if (currentLanguage === "ar" || currentLanguage === "en" || currentLanguage === "kor" || currentLanguage === "ru" || currentLanguage === 'zh' || currentLanguage === 'ja') {
          // Add language prefix if not already present
          if (pathSegments[0] !== currentLanguage) {
            pathSegments.unshift(currentLanguage);
          }
        } else if (
          (currentLanguage === "fr" && pathSegments[0] === "ar") ||
          pathSegments[0] === "en"||
          pathSegments[0] === "ru" || pathSegments[0] === 'ja' || pathSegments[0] === 'zh'  || currentLanguage === "kor"
        ) {
          // Remove language prefix if "fr" (default)
          pathSegments.shift();
        }
  
        url.pathname = "/" + pathSegments.join("/"); // Construct the new path
        const canonicalUrl = url.toString(); // Get the full URL as a string
  
        if (canonicalLink) {
          // Update the existing canonical link
          canonicalLink.setAttribute("href", canonicalUrl);
        } else {
          // Create a new canonical link
          canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", canonicalUrl);
          document.head.appendChild(canonicalLink);
        }
      },
      async loadBannerData() {
        try {
          const data = await this.fetchBanners();
          let arrayBanners = Object.values(data);
          this.imageListBanner1 = arrayBanners[0];
          this.imageListBanner2 = arrayBanners[1];
          this.imageListBanner3 = arrayBanners[2];
        } catch (error) {
          console.error("Error loading banners: ", error);
        }
      },
      async loadArticles() {
        try {
          const articlesList = await this.fetchArticles();
          this.articles = articlesList;
        } catch (error) {
          console.error("Error loading articlesList: ", error);
        }
      },
      updateMetaTags(hotel) {
         let myUrl=this.$props.parentUrl.replace(/^\//, '')
         metaTagsPage(hotel,myUrl,this.currentLanguage)
      },
    },
    watch: {
      "$i18n.locale"(newLocale) {
        this.currentLanguage = newLocale;
        this.addCanonicalLink();
        this.updateMetaTags(this.$props.element);
      },
    },
    async created() {
      this.updateMetaTags(this.$props.element);
      this.$store.dispatch("setLoading", true);
      try {
        await Promise.all([this.loadBannerData(), this.loadArticles()]);
      } catch (error) {
        console.log("error ", error);
      } finally {
        this.$store.dispatch("setLoading", false);
      }
    },
  };
  </script>
  